import React from 'react';
import { toast } from 'react-toastify';

import { useTranslation } from '@common/hooks/translation';

let toastId = null;

const messageTypeDetails = {
  fixed: {
    position: 'bottom-center',
    hideProgressBar: true,
    draggable: false,
    closeButton: false,
    closeOnClick: false,
    autoClose: false,
    toastId: 'fixed-message',
  },
};

const ToastMessageContent = ({ message }) => {
  const t = useTranslation();
  const closeIcon = 'global-icon icon-toast-error';

  const customMessageKey = `terminal_message_${message}`;
  const customMessage = t(customMessageKey);

  return (
    <>
      <i className={closeIcon} />
      {customMessage === customMessageKey ? (
        Array.isArray(message) ? t(...message) : t(message)
      ) : customMessage}
    </>
  );
};

const ToastWrapper = (type, message, containerId = 'Main-Toastify', messageType) => {
  const params = {
    icon: false,
    containerId,
    className: `toast-${type}-container`,
    ...messageTypeDetails[messageType],
  };

  if (!toast.isActive(toastId) || toastId === 'fixed-message') {
    toastId = toast[type](<ToastMessageContent message={message} />, params);
  }
};

export default ToastWrapper;
